import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] border-t border-[#141414] py-[28px] px-5 text-center" data-id="element-65">
      <p className="text-[0.78rem] text-[#383838] font-montserrat leading-[1.7]" data-id="element-66">
        © 2024 El Código del Control — Todos los derechos reservados.
        <br data-id="element-67" />
        <a href="#" className="text-[#484848] hover:text-brand-red transition-colors" data-id="element-68">
          Política de Privacidad
        </a>
        &nbsp;·&nbsp;
        <a href="#" className="text-[#484848] hover:text-brand-red transition-colors" data-id="element-69">
          Términos y Condiciones
        </a>
        &nbsp;·&nbsp;
        <a href="#" className="text-[#484848] hover:text-brand-red transition-colors" data-id="element-70">
          Contacto
        </a>
      </p>
      <p className="mt-2 text-[0.78rem] text-[#383838] font-montserrat leading-[1.7]" data-id="element-71">
        Este producto es de naturaleza educativa e informativa. Los resultados
        individuales pueden variar.
      </p>
    </footer>;
}